/**
 * Алиас Яндекса
 *
 * @name constants.YANDEX
 * @type {string}
 */
export const YANDEX = 'yandeks-plyus';

/**
 * Типы попапов
 *
 * @name constants.TYPES_POPUP
 * @type {enum}
 */
export enum TYPES_POPUP {
    partners = 'partners',
}
